import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { ClientImpl } from "../model/impl/ClientImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class ClientImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: ClientImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.bookingCode != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(1),
        false,
        encodable.bookingCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.branchCd != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(2),
        false,
        encodable.branchCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.clientId != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(3),
        false,
        encodable.clientId,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.clientName != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(4),
        false,
        encodable.clientName,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.salesGroup != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(5),
        false,
        encodable.salesGroup,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.salesGroupId != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(6),
        false,
        encodable.salesGroupId,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.straightThroughProcessingFg != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(7),
        false,
        encodable.straightThroughProcessingFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.allowPartialFillFg != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(8),
        false,
        encodable.allowPartialFillFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.autoFillEnabled != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(9),
        false,
        encodable.autoFillEnabled,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.defaultClientComment != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(10),
        false,
        encodable.defaultClientComment,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.defaultPrivateComment != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(11),
        false,
        encodable.defaultPrivateComment,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.reverseEngineerTPFg != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(12),
        false,
        encodable.reverseEngineerTPFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.reverseEngineerSLFg != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(13),
        false,
        encodable.reverseEngineerSLFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.traderVisibleFg != null) {
      this.baseEncoder.writeStartFid(14, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(14),
        false,
        encodable.traderVisibleFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(14, streamout);
    }
    /*Object encoding*/
    if (encodable.ordersEnabledFg != null) {
      this.baseEncoder.writeStartFid(15, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(15),
        false,
        encodable.ordersEnabledFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(15, streamout);
    }
    /*Object encoding*/
    if (encodable.stpAggregationDefaultFg != null) {
      this.baseEncoder.writeStartFid(16, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(16),
        false,
        encodable.stpAggregationDefaultFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(16, streamout);
    }
    /*Object encoding*/
    if (encodable.defaultAccountCd != null) {
      this.baseEncoder.writeStartFid(17, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(17),
        false,
        encodable.defaultAccountCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(17, streamout);
    }
    /*Object encoding*/
    if (encodable.bmForwardPricing != null) {
      this.baseEncoder.writeStartFid(18, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(18),
        false,
        encodable.bmForwardPricing,
        streamout,
      );
      this.baseEncoder.writeEndFid(18, streamout);
    }
    /*Object encoding*/
    if (encodable.algoForwardPricing != null) {
      this.baseEncoder.writeStartFid(19, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(19),
        false,
        encodable.algoForwardPricing,
        streamout,
      );
      this.baseEncoder.writeEndFid(19, streamout);
    }
    /*Object encoding*/
    if (encodable.autoRollFFOrders != null) {
      this.baseEncoder.writeStartFid(20, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(20),
        false,
        encodable.autoRollFFOrders,
        streamout,
      );
      this.baseEncoder.writeEndFid(20, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,ClientImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.String"],
    [2, "java.lang.String"],
    [3, "java.lang.String"],
    [4, "java.lang.String"],
    [5, "java.lang.String"],
    [6, "java.lang.Long"],
    [7, "java.lang.Boolean"],
    [8, "java.lang.Boolean"],
    [9, "java.lang.Boolean"],
    [10, "java.lang.String"],
    [11, "java.lang.String"],
    [12, "java.lang.Boolean"],
    [13, "java.lang.Boolean"],
    [14, "java.lang.Boolean"],
    [15, "java.lang.Boolean"],
    [16, "java.lang.Boolean"],
    [17, "java.lang.String"],
    [18, "com.bcdfx.model.ForwardPricingType"],
    [19, "com.bcdfx.model.ForwardPricingType"],
    [20, "java.lang.Boolean"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: ClientImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.bookingCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.branchCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.clientId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.clientName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.salesGroup = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.salesGroupId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.straightThroughProcessingFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.allowPartialFillFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.autoFillEnabled = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.defaultClientComment = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.defaultPrivateComment = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.reverseEngineerTPFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.reverseEngineerSLFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 14: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(14),
            streamin,
          );
          encodable.traderVisibleFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 15: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(15),
            streamin,
          );
          encodable.ordersEnabledFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 16: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(16),
            streamin,
          );
          encodable.stpAggregationDefaultFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 17: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(17),
            streamin,
          );
          encodable.defaultAccountCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 18: {
          /*Object encoding*/
          let val: CubiqTS.ForwardPricingType = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(18),
            streamin,
          );
          encodable.bmForwardPricing = <CubiqTS.ForwardPricingType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 19: {
          /*Object encoding*/
          let val: CubiqTS.ForwardPricingType = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(19),
            streamin,
          );
          encodable.algoForwardPricing = <CubiqTS.ForwardPricingType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 20: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(20),
            streamin,
          );
          encodable.autoRollFFOrders = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,ClientImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return ClientImplEncoder.fidTypeMap.has(fid);
  }
}
